export const getAuthToken = () => "";
